<template>
  <div class="media-image">
    <div class="media-image-img">
      <img v-if="imageSrc" :src="imageSrc" alt="Media image" />
    </div>

    <div class="media-image-buttons">
      <div class="field has-addons">
        <p class="control">
          <upload-image
            ref="uploader"
            :endpoint="`/admin/api/marketing/banners/${bannerId}/image`"
            file-field-name="image"
            :additional="{ size }"
            @uploaded="uploaded"
          >
            <button type="button" class="button is-small is-primary" slot="trigger">
              <b-icon icon="upload"></b-icon>
              <span>Upload</span>
            </button>
          </upload-image>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import UploadImage from "@/components/UploadImage";

export default {
  components: {
    UploadImage
  },

  props: {
    bannerId: {
      type: String
    },

    src: {
      type: String
    },

    size: {
      type: String
    }
  },

  data() {
    return {
      imageSrc: this.src
    };
  },

  methods: {
    uploaded({ url }) {
      this.imageSrc = url;
    }
  }
};
</script>
